import { AppContainer } from 'components/common/appContainer';
import { Users } from './index';

const UsersPage = () => {
    return (
        <AppContainer>
            <Users renderButtons renderFilter />
        </AppContainer>
    );
};

export { UsersPage };
